var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useSWR from 'swr';
import { getCurrentAccountID, safeLogError } from '../../utils';
export const fetchSession = (options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const sessionResponse = yield fetch(`${(_a = options === null || options === void 0 ? void 0 : options.baseURL) !== null && _a !== void 0 ? _a : ''}/api/v4/session/`, (options === null || options === void 0 ? void 0 : options.zapsession)
        ? {
            headers: {
                Cookie: `zapsession=${options.zapsession};`,
            },
        }
        : {});
    if (!sessionResponse.ok) {
        throw new Error(`Request to fetch user session failed. Status: ${sessionResponse.status}. Message: ${sessionResponse.statusText}`);
    }
    const session = yield sessionResponse.json().catch(safeLogError);
    return session;
});
export const useSession = (shouldFetch = true) => {
    var _a, _b, _c;
    const { data, error, isLoading } = useSWR(`/api/v4/session/${shouldFetch}`, () => {
        return shouldFetch ? fetchSession() : null;
    });
    if (error) {
        safeLogError(error);
    }
    return {
        data: data
            ? Object.assign(Object.assign({}, data), { current_account_role: (_c = (_b = (_a = data.roles) === null || _a === void 0 ? void 0 : _a.find((role) => role.account_id === getCurrentAccountID())) === null || _b === void 0 ? void 0 : _b.role) !== null && _c !== void 0 ? _c : '' }) : null,
        error,
        isLoading,
    };
};
//# sourceMappingURL=data.js.map